import {
    EDIT_SECRET_GENERALES,
    EDIT_SECRET_RESET
} from "../redux-const";

const initialState = {
    loading: false,
    tab: 0,
    new: true,
    key: "",
    value: "",
    description: "",
}


export const reducer = (state = initialState, action) => {
    const payload = action.payload;

    switch (action.type) {
        case EDIT_SECRET_GENERALES:
            return {
                ...state,
                ...payload
            }
        case EDIT_SECRET_RESET:
            return initialState
        default:
            return state
    }
};

export default reducer;
